import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  CREATE_CAMPANHA_INIT,
  UPDATE_CAMPANHA_INIT,
  CAMPANHA_LIST_CAMPANHA_INIT,
  CAMPANHA_OBTEM_CAMPANHA_INIT,
  CAMPANHA_DELETE_CAMPANHA_INIT,
  DUPLICATE_CAMPANHA_INIT
} from '../actionTypes';
import {
  createCampanhaSucess,
  updateCampanhaSuccess,
  campanhaErrorMsg,
  obtemCampanhasListSuccess,
  obtemCampanhaSuccess,
  campanhaDeleteCampanhaSuccess,
  duplicateCampanhaSuccess
} from './actions';

import { FarmaError } from 'src/integracoes/modelos/erros';
import { ICampanha } from 'src/integracoes/servicos/mongo-atlas/modelos/ICampanha';
import { atualizarCampanha, criarCampanha, deletarCampanha, duplicarCampanha, listarCampanha, listarCampanhas } from 'src/integracoes/servicos/mongo-atlas/funcoes/campanhas';

interface FetchListaCampanhasResult {
  isError: boolean;
  campanhas: ICampanha[] | null;
  msg: string | null;
}

interface FetchCampanhaResult {
  isError: boolean;
  campanha: ICampanha | null;
  msg: string | null;
}

/* ------------------Lista campanhas empresa---------------- */
export const fetchListarCampanhas = async (empId: string): Promise<FetchListaCampanhasResult> => {
  try {
    const { status, dados, mensagem } = await listarCampanhas(empId);

    if (status && Array.isArray(dados)) {
      return {
        isError: false,
        campanhas: dados,
        msg: mensagem,
      };
    }

    return {
      isError: true,
      campanhas: [],
      msg: mensagem,
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarCampanhas({ payload }: { payload: { empId: string }; type: any }) {
  const { empId } = payload;
  try {
    const { isError, campanhas, msg } = yield call(fetchListarCampanhas, empId);

    if (!isError) {
      yield put(obtemCampanhasListSuccess({ campanhas }));
    } else {
      yield put(campanhaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(campanhaErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchListarCampanhas() {
  yield takeEvery(CAMPANHA_LIST_CAMPANHA_INIT, parseListarCampanhas);
}

/* ------------------Lista campanha Id ---------------- */
export const fetchListarCampanhaId = async (id: string): Promise<FetchCampanhaResult> => {
  try {
    const { status, dados, mensagem } = await listarCampanha(id);

    if (status) {
      return {
        isError: false,
        campanha: dados as ICampanha,
        msg: mensagem,
      };
    }

    return {
      isError: true,
      campanha: null,
      msg: mensagem,
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarCampanhaId({ payload }: { payload: { id: string }; type: any }) {
  const { id } = payload;

  try {
    const { isError, msg, campanha }: FetchCampanhaResult = yield call(fetchListarCampanhaId, id);
    if (!isError) {
      yield put(obtemCampanhaSuccess({ campanha: campanha }));
    } else {
      yield put(campanhaErrorMsg({ msg: msg }));
    }
  } catch (error: any) {
    yield put(campanhaErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchListarCampanhaId() {
  yield takeEvery(CAMPANHA_OBTEM_CAMPANHA_INIT, parseListarCampanhaId);
}

/* ------------------Criar campanha ---------------- */
export const fetchCriarCampanha = async (campanha: any) => {
  try {
    const { status, dados, mensagem } = await criarCampanha(campanha);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarCampanha({ payload }: { payload: any, type: any }) {
  const { dados } = payload;

  try {
    const { isCreated, msg, data } = yield call(fetchCriarCampanha, dados);
    if (isCreated) {
      yield put(createCampanhaSucess({ current: data, msg: msg }));
    } else {
      yield put(campanhaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      campanhaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchCriarCampanha() {
  yield takeEvery(CREATE_CAMPANHA_INIT, parseCriarCampanha);
}

/* ------------------Atualiza campanha ---------------- */
export const fetchAtualizarCampanha = async (id: string, campanha: any) => {
  try {
    const { status, dados, mensagem } = await atualizarCampanha(id, campanha);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizarCampanha({ payload }: { payload: any; type: any }) {
  const { id, campanha } = payload;
  try {
    const { isUpdated, msg, data } = yield call(fetchAtualizarCampanha, id, campanha);

    if (isUpdated) {
      yield put(updateCampanhaSuccess({ id, campanha: data, msg }));
    } else {
      yield put(campanhaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(

      campanhaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchAtualizarCampanha() {
  yield takeEvery(UPDATE_CAMPANHA_INIT, parseAtualizarCampanha);
}

/* ------------------Deletar campanha ---------------- */
export const fetchDeletarCampanha = async (id: string) => {
  try {
    const { status, mensagem } = await deletarCampanha(id);
    if (status) {
      return { isUpdated: true, msg: mensagem };
    } else {
      return {
        isUpdated: false,
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDeletarCampanha({ payload }: { payload: any; type: any }) {
  const { id } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchDeletarCampanha, id);

    if (isUpdated) {
      yield put(campanhaDeleteCampanhaSuccess({ id, msg }));
    } else {
      yield put(campanhaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      campanhaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchDeletarCampanha() {
  yield takeEvery(CAMPANHA_DELETE_CAMPANHA_INIT, parseDeletarCampanha);
}

/* ------------------Duplicar campanha ---------------- */
export const fetchDuplicarCampanha = async (id: string) => {
  try {
    const { status, mensagem, dados } = await duplicarCampanha(id);
    if (status) {
      return { isUpdated: true, msg: mensagem, data: dados };
    } else {
      return {
        isUpdated: false,
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDuplicarCampanha({ payload }: { payload: any; type: any }) {
  const { id } = payload;
  try {
    const { isUpdated, msg, data } = yield call(fetchDuplicarCampanha, id);

    if (isUpdated) {
      yield put(duplicateCampanhaSuccess({ campanha: data, msg }));
    } else {
      yield put(campanhaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      campanhaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchDuplicarCampanha() {
  yield takeEvery(DUPLICATE_CAMPANHA_INIT, parseDuplicarCampanha);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchListarCampanhas),
    fork(watchListarCampanhaId),
    fork(watchCriarCampanha),
    fork(watchAtualizarCampanha),
    fork(watchDeletarCampanha),
    fork(watchDuplicarCampanha),
  ])
}
